//library
import { useState, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { BrowserRouter as Router } from 'react-router-dom';

//theme
import { darkTheme, lightTheme } from './utils/Themes.js'
//css
import './App.css';

//components
import Navbar from "./components/Navbar";
import Home from "./components/home/Home";
import About from "./components/About"; 
import Events from "./components/events/Events";
import EventDetails from "./components/events/EventDetails";

import Skills from "./components/Skills";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import styled from "styled-components";
import Developers from "./components/Achievements/index.js";
import Sponsor from "./components/Sponsor/index.js";

//images
import NirmanBG from "./images/bg.png"
import NirmanLogo from "./images/Logo2.png"
//-----------------------------------------------------------------------------------------


const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
  padding:20px;
`;

const Wrapper = styled.div`
  background: linear-gradient(38.73deg, rgba(204, 0, 187, 0.15) 0%, rgba(201, 32, 184, 0) 50%), linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.15) 100%);
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%,30% 98%, 0 100%);
`;

export const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  margin-bottom: 30px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    font-size: 32px;
    max-width : 20em;
  }

  @media (max-width: 500px) {
    font-size: 32px;
    max-width : 10em;
  }

  position: absolute;
  top : 1em;
`;
  

function App()
{
  const [darkMode, setDarkMode] = useState(true);
  const [openModal, setOpenModal] = useState({
    state: false,
    project: null
  });
  
  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>

        <Navbar/>
        

        <Home/>
        <Body>
          <About />

          <Events openModal={openModal} setOpenModal={setOpenModal} />
          {
            openModal.state && <EventDetails openModal={openModal} setOpenModal={setOpenModal} />
          }
          
             
            <Experience />
            <Education />
            <Skills/>
  
            <Wrapper>
              <Sponsor/>
            </Wrapper>

            <Developers/>
            <Footer/> 
        </Body>

      </Router>
    </ThemeProvider>
  );
}

export default App;
